import { Component, Output, EventEmitter, ViewChildren,
  OnInit, OnChanges, SimpleChanges, QueryList, Input } from '@angular/core';
import { Parametric } from '../../../parametric.model';
import { ExpansorWithChipComponent, IFilterOption, ISelectedValue } from '../../../../shared-components/expansor-with-chip/expansor-with-chip.component';
import { ExpansorWithSearchComponent } from '../../../../shared-components/expansor-with-search/expansor-with-search.component';
import { ExpansorWithChipMultipleComponent } from '../../../../shared-components/expansor-with-chip-multiple/expansor-with-chip-multiple.component';
import { Tag } from '../../../../cliente/tag.model';
import { MediaService } from '../../../../shared-services/media.service';
import { ApiService } from '../../../../core/api.service';
import moment = require('moment');

export interface ISelectedChip {
  chipKey: string;
  chipLabel: string;
  categoryName: string;
  tagId: any;
  selectedChipFilterComponent: any; // Componente del viewChild
}

export interface DocChangeResponse {
  selectedChips: ISelectedChip[];
  selectedDocs: Parametric[];
}

export interface GenericFilter {
  id: number;
  label: string;
  selected: boolean;
  filter: string;
}

@Component({
  selector: 'app-productos-buscados-filter',
  templateUrl: './productos-buscados-filter.component.html',
  styleUrls: ['./productos-buscados-filter.component.scss']
})


export class ProductosBuscadosFilterComponent implements OnInit, OnChanges {

  isMobile: boolean;

  encuentraProductos: boolean;
  fechaUltimaCompra: string;
  ultimaConexion: string;
  ultimaCompra: string;
  estado: Parametric;

  @Input() showEstado = true;
  @Input() selectedChips: ISelectedChip[] = [];
  private estados: Parametric[];

  estadoFilterValues: IFilterOption[] = [];
  ultimaCompraFilterValues: IFilterOption[] = [];
  productoEncontradoFilterValues: IFilterOption[] = []; 

  @ViewChildren('productoEncontradoFilter') private productoEncontradoComponent : ExpansorWithChipComponent;
  @ViewChildren('ultimaCompraFilter') private ultimaCompraFilterComponent: ExpansorWithChipComponent;
  @ViewChildren('fechaUltimaCompraFilter') private fechaUltimaCompraComponent: ExpansorWithSearchComponent;
  @ViewChildren('estadoFilter') private estadoComponent: ExpansorWithChipMultipleComponent<Tag>;
  @Output() onFilterChange = new EventEmitter<ISelectedChip[]>();
  @Output() onHide = new EventEmitter<void>();

  async getProductosEncontrados() {
    this.productoEncontradoFilterValues.push({value: true, displayText: 'Encuentra Productos', class: ''});
    this.productoEncontradoFilterValues.push({value: false, displayText: 'No Encuentra Productos', class: ''});
  }

  async getUltimaCompraValues() {
    this.ultimaCompraFilterValues.push({value: this.getFechaReciente(), displayText: 'Reciente', class: ''});
    this.ultimaCompraFilterValues.push({value: this.getFechaHacePoco(), displayText: 'Hace poco', class: ''});
    this.ultimaCompraFilterValues.push({value: this.getFechaHaceMucho(), displayText: 'Hace mucho', class: ''});
  }

  async getEstados() {
    this.apiService.get(Parametric, Parametric.path + 'estados_pedidos/', null).toPromise().then(value => {
      this.estados = value;
      var vendidos = "";
      for (const estado of this.estados){
        this.estadoFilterValues.push({value: estado.id.toString(), displayText: estado.description, class: ''});
        vendidos = this.filtroVendidos(this.estados);
      }
      this.estadoFilterValues.push({value: vendidos, displayText: "Vendidos", class:''})
    });
  }

  constructor(
    private mediaService: MediaService,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
    this.getUltimaCompraValues();
    this.getEstados();
    this.getProductosEncontrados();
  }

  ngOnChanges(changes: SimpleChanges) {}

  onRemoveChip(selectedChip: ISelectedChip) {
    selectedChip.selectedChipFilterComponent.onRemoveChip();
    this.selectedChips = this.selectedChips.filter(x => x.chipKey !== selectedChip.chipKey);
    this.filterChange();
  }

  onUltimaCompraChange(selectedFilter: ISelectedValue) {
    this.addChip('ultimaCompraFilter', selectedFilter.viewValue, selectedFilter, this.ultimaCompraFilterComponent);
    this.ultimaCompra = selectedFilter.value;
    this.filterChange();
  }

  onFechaUltimaCompraChange(selectedFilter: ISelectedValue) {
    this.addChip('fechaUltimaCompraFilter', selectedFilter.viewValue, selectedFilter, this.fechaUltimaCompraComponent);
    this.fechaUltimaCompra = selectedFilter.value;
    this.filterChange();
  }

  onEstadoChange(selectedFilter: ISelectedValue) {
    this.addChip('estadoFilter', selectedFilter.viewValue, selectedFilter, this.estadoComponent);
    this.estado = selectedFilter.value;
    this.filterChange();
  }

  onProductoEncontradoChange(selectedFilter: ISelectedValue) {
    this.addChip('productoEncontradoFilter', selectedFilter.viewValue, selectedFilter, this.productoEncontradoComponent);
    this.encuentraProductos = selectedFilter.value;
    this.filterChange();
  }

  addMultipleChip(chips: any[], categoryName: string, chipName: string, component: ExpansorWithChipMultipleComponent<Tag>) {
    this.selectedChips = this.selectedChips.filter(x => x.categoryName !== categoryName);

    for (const chip of chips) {
      const chipKey = chipName + chip.value;

      if (!this.selectedChips.find(x => x.chipKey === chipKey)) {
        const selectedFilter = { value: chip.value, categoryName: categoryName, viewValue: chip.displayText };
        this.addChip(chipKey, chip.displayText, selectedFilter, component);
      }
    }
  }

  filterChange() {
    this.onFilterChange.emit(this.selectedChips);
  }

  addChip(chipKey: string, chipLabel: string, selectedFilter: ISelectedValue, selectedChipFilterComponent: any): ISelectedChip {
    if (selectedFilter.value === undefined) {
      return;
    }

    if (this.selectedChips.find(x => x.chipKey === chipKey)) {
      return;
    }

    const selectedChipInstance: ISelectedChip =  {
      chipKey: chipKey,
      chipLabel: chipLabel,
      categoryName: selectedFilter.categoryName,
      tagId: selectedFilter.tagID !== undefined ? selectedFilter.tagID : selectedFilter.value,
      selectedChipFilterComponent: (<QueryList<ExpansorWithChipComponent>>selectedChipFilterComponent).first
    };

    this.selectedChips.push(selectedChipInstance);
  } 

  onTogglePickerFrom(event: any) {
    event.stopPropagation();
  }

  onTogglePickerTo(event: any) {
    event.stopPropagation();
  }

  getFechaReciente() {
    return this.getFecha(3);
  }

  getFechaHacePoco() {
    return this.getFecha(15);
  }
  getFechaHaceMucho() {
    return this.getFecha(60);
  }

  getFecha(val: number) {
    const d = new Date();
    d.setDate(new Date().getDate() - val);
    return moment(d).format('YYYY-MM-DD');
  }

  filtroVendidos(estados){
    var vendidos = "";
    for (const estado of estados){
      if(estado.description == "Preparando" || estado.description == "Pagado" || estado.description == "Facturado"){
        vendidos += estado.id.toString() + ",";
      }
    }
    vendidos = vendidos.substring(0, vendidos.length - 1)
    return vendidos;
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/productos-buscados/filter/productos-buscados-filter/productos-buscados-filter.component.ts